/**
 * Dependencies.
 */
import { createElement as el } from "@wordpress/element";
import AppConfig from "../../services/appConfig";
import "./languageButton.css";

interface ButtonProps {
  onClick: Function;
  onMouseEnter?: Function;
  onMouseLeave?: Function;
}

const getImageUrl = (languageFlagUrl: any, currentLanguage: string) => {
  return languageFlagUrl[currentLanguage];
};
/**
 * Provides a LanguageButton.
 *
 * @return {element} LanguageButton.
 */
const LanguageButton = (props: ButtonProps) => {
  const { enLanguageName, currentLanguage, languageFlagUrl } = AppConfig();
  return el(
    "button",
    {
      type: "button",
      className:
        "components-button is-primary wpglobus-switcher-components-button",
      style: {},
      //isLink: false,
      onClick: props.onClick,
      onMouseLeave: props.onMouseLeave,
    },
    el("img", {
      src: getImageUrl(languageFlagUrl, currentLanguage),
      width: 20,
      height: 20,
      className: "wpglobus-switcher-flag",
    }),
    el(
      "span",
      { className: "wpglobus-switcher-language" },
      enLanguageName[currentLanguage]
    )
  );
};

export default LanguageButton;
